import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Rooms.css';

import roomCh1 from '../assets/imgs/rooms-ch1.png';
import roomCh2 from '../assets/imgs/rooms-ch2.png';
import roomCh3 from '../assets/imgs/rooms-ch3.png';
import roomCh4 from '../assets/imgs/rooms-ch4.png';
import combo from '../assets/imgs/rooms-combo-2.png';

class Rooms extends Component {
  render() {
    return (
      <div className="Rooms" ref={div => (this.appContainer = div)}>
        <Header />
        <div className="Rooms-container">
          <div className="Room-top"></div>
          <div className="Room-mid">
            <div className="Room-header">ROOMS</div>
            <hr />
            <div className="Room-listing">
              <div>
                <div className="Room-title">THE BUNKER</div>
                <div className="Room-img">
                  <NavLink exact to="/chapter1">
                    <img src={roomCh1} alt="" />
                  </NavLink>
                </div>
              </div>
              <div>
                <div className="Room-title">THE HIVE</div>
                <div className="Room-img">
                  <NavLink exact to="/chapter2">
                    <img src={roomCh2} alt="" />
                  </NavLink>
                </div>
              </div>
              <div>
                <div className="Room-title">THE GATEKEEPER</div>
                <div className="Room-img">
                  <NavLink exact to="/chapter3">
                    <img src={roomCh3} alt="" />
                  </NavLink>
                </div>
              </div>
              <div>
                <div className="Room-title">INFECTED</div>
                <div className="Room-img">
                  <NavLink exact to="/chapter4">
                    <img src={roomCh4} width={325} alt="" />
                  </NavLink>
                </div>
              </div>
              <div>
                <div className="Room-title">COMBO</div>
                <div className="Room-img">
                  <NavLink exact to="/combo">
                    <img src={combo} alt="" />
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
          <div className="Room-bottom"></div>
        </div>
        <a href="https://thebunkerexperienceonline.com/">
                            <div className="banner-tout"></div>
                        </a>

        <Footer />
      </div>
    );
  }
}

export default Rooms;
